import React, { FC } from 'react';

import { Flex } from 'Src/components/layout/Flex';
import { useCurrentCheck } from 'Src/feature/check/useCurrentCheck';
import { buildKeyFromObject } from 'Src/utils/object';

import CheckActivityRow from './CheckActivityRow';

import style from './CheckActivityTab.module.scss';

const CheckActivityTab: FC = () => {
  const currentCheck = useCurrentCheck();
  return (
    <Flex gap="xs" className={style['root']}>
      {currentCheck.query.data?.activities.map((activity) => (
        <CheckActivityRow key={buildKeyFromObject('CheckActivityTab', activity)} activity={activity} check={currentCheck.query.data} />
      ))}
    </Flex>
  );
};

export { CheckActivityTab };
